import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { SpfDkimDmarcHeroSection } from "@/components/insights/spf-dkim-dmarc/SpfDkimDmarcHeroSection";
import { SpfDkimDmarcTakeaway } from "@/components/insights/spf-dkim-dmarc/SpfDkimDmarcTakeaway";
import { SpfDkimDmarcFounderQuote } from "@/components/insights/spf-dkim-dmarc/SpfDkimDmarcFounderQuote";
import { SpfDkimDmarcKeyFindings } from "@/components/insights/spf-dkim-dmarc/SpfDkimDmarcKeyFindings";
import { SpfDkimDmarcProtocols } from "@/components/insights/spf-dkim-dmarc/SpfDkimDmarcProtocols";
import { SpfDkimDmarcImplementation } from "@/components/insights/spf-dkim-dmarc/SpfDkimDmarcImplementation";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const SpfDkimDmarcGuide = () => {
  return (
    <>
      <InsightSEO 
        slug="spf-dkim-dmarc-guide" 
        additionalKeywords={["SPF record", "DKIM signature", "DMARC policy", "email authentication", "DNS records"]}
      />
      <InsightEngagementTracker slug="spf-dkim-dmarc-guide" title="SPF, DKIM & DMARC Guide" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Technical" 
          currentPage="SPF, DKIM & DMARC Guide" 
        />
        <SpfDkimDmarcHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <SpfDkimDmarcTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <SpfDkimDmarcFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <SpfDkimDmarcKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <SpfDkimDmarcProtocols />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <SpfDkimDmarcImplementation />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="spf-dkim-dmarc-guide" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="spf-dkim-dmarc-guide" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="spf-dkim-dmarc-guide" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default SpfDkimDmarcGuide;
